import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TreeTableModule } from 'primeng/treetable';
import { CategoriesTreeTableComponent } from './categories-tree-table.component';

@NgModule({
  declarations: [CategoriesTreeTableComponent],
  imports: [
    CommonModule,
    TreeTableModule,
    ButtonModule,
    InputSwitchModule,
    InputNumberModule,
    ReactiveFormsModule,
    InputTextModule,
    RouterModule
  ],
  exports: [CategoriesTreeTableComponent],
  providers: [DatePipe]
})
export class CategoriesTreeTableModule {}
